import { Component, Input } from '@angular/core';

/**
 * Generated class for the HeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'dbheader',
  templateUrl: 'header.html'
})
export class HeaderComponent {

    @Input('showSettings') settings: any;
    @Input('showBack') back: any;
    @Input('gradientHeader') gradientHeader: any;
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts